import { Amplify } from 'aws-amplify';
import { decryptCredentials } from './cifrate';

export const apiKeyDecode = decryptCredentials(process.env.REACT_APP_KEY_CHECKOUT_VISA);
export const altServer = decryptCredentials(process.env.REACT_APP_ALT_URL_SERVER);
export const urlLbliv = decryptCredentials(process.env.REACT_APP_URL_LBLIV);
export const region = decryptCredentials(process.env.REACT_APP_AWS_REGION);

const amplifyConfig = () => {
  const endpoints = [
    {
      name: 'LEAD',
      endpoint: decryptCredentials(process.env.REACT_APP_LEAD_API),
      region,
    },
    {
      name: 'SALFLEX',
      endpoint: decryptCredentials(process.env.REACT_APP_SALESFLEX_API),
      region,
    },
    {
      name: 'PERSON',
      endpoint: decryptCredentials(process.env.REACT_APP_API_PERSON),
      region,
    },
    {
      name: 'CORE',
      endpoint: decryptCredentials(process.env.REACT_APP_CORE_API),
      region,
    },
    {
      name: 'UTILITARIOS',
      endpoint: decryptCredentials(process.env.REACT_APP_UTILITARIOS),
      region,
    },
    {
      name: 'CANALVIDA',
      endpoint: decryptCredentials(process.env.REACT_APP_GENERAL),
      region,
    },
    {
      name: 'CANALCROSS',
      endpoint: decryptCredentials(process.env.REACT_APP_URL_API_CROSS_CANAL),
      region,
    },
  ];

  Amplify.configure({
    Auth: {
      region,
      identityPoolId: decryptCredentials(process.env.REACT_APP_AWS_IDENTITY_POOL_ID),
    },
    API: {
      endpoints,
    },
    Storage: {
      region,
    },
  });

  return endpoints;
};

export default {
  amplifyConfig,
};
